const SvgIcon = ({size='24', color='#a59e9e'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg863"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      id="path861"
      fill={color}
      fillOpacity="0.98"
      strokeWidth="1"
      d="M.387 3.6h9.29V0H12v24H9.677v-4.8H5.032v-3.6h4.645v-2.4H2.71V9.6h6.967V7.2H.387Zm13.936 0h3.483v3.6h-3.483zm0 6h5.806v3.6h-5.806zm0 6h9.29v3.6h-9.29z"
    ></path>
  </svg>
);

export default SvgIcon;
